export const LATEST = 'LATEST';
export const AWARDS = 'AWARDS';
export const VIDEOS = 'VIDEOS';

export default [
  {
    id: AWARDS,
    content: (
      <>
        Awards &
        <br />
        Recognition
      </>
    ),
  },
  {
    id: LATEST,
    content: (
      <>
        Latest
        <br />
        News
      </>
    ),
  },
  {
    id: VIDEOS,
    content: 'Videos',
  },
];
